import { createContext, useCallback, useContext, useMemo } from 'react'

interface DataGridConfigValue {
  valueOptionsLookupTable: Record<string, string[]>
}

const DataGridConfig = createContext<DataGridConfigValue>({
  valueOptionsLookupTable: {}
})

export function DataGridConfigProvider({ children, valueOptionsLookupTable }: React.PropsWithChildren<DataGridConfigValue>) {
  const contextValue = useMemo(() => {
    return {
      valueOptionsLookupTable
    }
  }, [valueOptionsLookupTable])

  return <DataGridConfig.Provider value={contextValue}>{children}</DataGridConfig.Provider>
}

export function useDataGridConfig() {
  const context = useContext(DataGridConfig)

  const queryValueOptions = useCallback(
    (enumerable: string): string[] => {
      return context.valueOptionsLookupTable[enumerable] ?? []
    },
    [context.valueOptionsLookupTable]
  )

  return useMemo(
    () => ({
      queryValueOptions
    }),
    [queryValueOptions]
  )
}
